import { Button, ButtonProps } from "@mui/material";
import React from "react";

interface Props extends ButtonProps {
  children: React.ReactNode;
}

const MuiButton: React.FC<Props> = (props: Props) => {
  const { sx, children, ...rest } = props;
  const styles: typeof sx = { textTransform: "capitalize",borderRadius:2, fontWeight: 500, ...sx };

  return (
    <Button disableElevation disableRipple sx={styles} {...rest} >
      {children}
    </Button>
  );
};

export default MuiButton;
